import { createAction } from '@reduxjs/toolkit';

import type { UserOverridesItemRequest } from 'js/src/client';
import type { UserOverrides } from 'js/src/data/user-overrides/user-overrides-types';
import { USER_OVERRIDES_ACTIONS } from 'js/src/data/user-overrides/user-overrides-types';

export const hydrateOverrides = createAction<{
    overrides: UserOverrides;
    systemTriggered: boolean;
    parentActionGroup: string | undefined;
}>(USER_OVERRIDES_ACTIONS.HYDRATE_OVERRIDES);

export const setAssetTimingOverride = createAction<{
    sceneId: string;
    assetId: string;
    isOverridden: boolean;
    systemTriggered: boolean;
    parentActionGroup: string | undefined;
}>(USER_OVERRIDES_ACTIONS.SET_ASSET_TIMING_OVERRIDE);

export const setTextPositionUserOverride = createAction<{
    sceneId: string;
    isAutomatic: boolean;
    systemTriggered: boolean;
    parentActionGroup: string | undefined;
}>(USER_OVERRIDES_ACTIONS.SET_SCENE_TEXT_POS_OVERRIDE);

export const setTextSizeUserOverride = createAction<{
    sceneId: string;
    isAutomatic: boolean;
    systemTriggered: boolean;
    parentActionGroup: string | undefined;
}>(USER_OVERRIDES_ACTIONS.SET_SCENE_TEXT_SIZE_OVERRIDE);

export const setTextAlignmentUserOverride = createAction<{
    sceneId: string;
    isAutomatic: boolean;
    systemTriggered: boolean;
    parentActionGroup: string | undefined;
}>(USER_OVERRIDES_ACTIONS.SET_SCENE_TEXT_ALIGNMENT_OVERRIDE);

export const setSceneDurationUserOverride = createAction<{
    sceneId: string;
    isAutomatic: boolean;
    systemTriggered: boolean;
    parentActionGroup: string | undefined;
}>(USER_OVERRIDES_ACTIONS.SET_SCENE_DURATION_OVERRIDE);

export const setCropUserOverride = createAction<{
    sceneId: string;
    isAutomatic: boolean;
    systemTriggered: boolean;
    parentActionGroup: string | undefined;
}>(USER_OVERRIDES_ACTIONS.SET_SCENE_CROP_OVERRIDE);

export const setKenburnUserOverride = createAction<{
    sceneId: string;
    isAutomatic: boolean;
    systemTriggered: boolean;
    parentActionGroup: string | undefined;
}>(USER_OVERRIDES_ACTIONS.SET_SCENE_KEN_BURN_OVERRIDE);

export const setBrightnessUserOverride = createAction<{
    sceneId: string;
    isAutomatic: boolean;
    systemTriggered: boolean;
    parentActionGroup: string | undefined;
}>(USER_OVERRIDES_ACTIONS.SET_SCENE_BRIGHTNESS_OVERRIDE);

export const setSceneOverrides = createAction<{
    sceneId: string;
    overrides: UserOverridesItemRequest;
    systemTriggered: boolean;
    parentActionGroup: string | undefined;
}>(USER_OVERRIDES_ACTIONS.SET_SCENE_OVERRIDES);
